/* eslint-disable */
import React, {useState} from "react";
import {IconButton, Modal, TextField} from "@material-ui/core";
import styles from "./EditCaption.module.css";
import EditIcon from "@material-ui/icons/Edit";
import PuiTypography from "../../../components/elements/PuiTypography";
import PuiButton from "../../../components/elements/PuiButton";
import {useDispatch, useSelector} from "react-redux";
import {EditVideoCaption} from "../../../store/actions/ExVideoActions";
import {AppState} from "../../../root/RootReducer";

interface EditCaptionProps {
    captionId: number;
    beforeEditText: string;
}

export default function EditCaption(
    {captionId, beforeEditText}: EditCaptionProps) {
    const dispatch = useDispatch();
    const {user} = useSelector((state: AppState) => ({
        user: state.user.userInfo
   }));

    // STT編集モーダル表示制御
    const [isOpenEditCaptionModal, ShowEditCaptionModal] = useState(false);
    const [isErrorInputCaption, ErrorInputCaption] = useState(false);
    const [inputCaption, InputCaption] = useState(beforeEditText);
    const [isUserInput, ChangeUserInputFlag] = useState(false);

    const OpenEditCaptionModal = () => {
        ShowEditCaptionModal(true);
   };

    const CloseEditCaptionModal = () => {
        ShowEditCaptionModal(false);
        ErrorInputCaption(false);
        ChangeUserInputFlag(false);
        InputCaption("");
   };

    const InputEditCaption =(event: any) => {
        console.log("InputEditCaption start");
        ChangeUserInputFlag(true);
        InputCaption(event.target.value);
   };

    const DoneEditInputCaption = () => {
        console.log("DoneEditInputCaption start");
        if(inputCaption !== "" && user){
            CloseEditCaptionModal();
            dispatch(EditVideoCaption({captionId: captionId, userId: user.id, beforeUpdateTranscript: beforeEditText, afterUpdateTranscript: inputCaption}));
       }else{
            ErrorInputCaption(true);
       }
   };

    return (
        <div>
            <IconButton onClick={OpenEditCaptionModal} className={styles.captionEditIcon}>
                <EditIcon style={{width: "20px",height: "20px", color:"var(--red)"}} color="secondary"/>
            </IconButton>

            {/* STT編集モーダル */}
            <Modal
                open={isOpenEditCaptionModal}
                onClose={CloseEditCaptionModal}
            >
                <div className={styles.captionEditModal}>
                    <div className={styles.editCaptionTitle}>
                        <PuiTypography size={16} bold={true}>テキストを修正</PuiTypography>
                    </div>
                    <div className={styles.editCaptionContent}>
                        <div className={styles.modalLeft}>
                            <div>
                                <PuiTypography size={20} bold={true}>修正前</PuiTypography>
                            </div>
                            <TextField disabled autoComplete="off"variant="outlined" multiline fullWidth rows={5} value={beforeEditText}/>
                        </div>
                        <div className={styles.modalRight}>
                            <div>
                                <PuiTypography size={20} bold={true}>修正後</PuiTypography>
                            </div>
                            <TextField color="secondary" onChange={InputEditCaption}  multiline fullWidth rows={5} autoComplete="off"
                                variant="outlined" defaultValue={beforeEditText}
                            />
                        </div>
                    </div>
                    <div className={styles.captionEditModalButton}>
                        <div className={styles.cancelButton}>
                            <PuiButton onClick={CloseEditCaptionModal}>キャンセル</PuiButton>
                        </div>
                        <div className={styles.updateButton}>
                            <PuiButton isActive={isUserInput}  onClick={DoneEditInputCaption}>更新</PuiButton>
                        </div>
                    </div>
                    <div className={styles.captionEditModalAlart} style={{visibility: isErrorInputCaption ? "visible" : "hidden"}}><p>※入力してください</p></div>
                </div>
            </Modal>


        </div>
    );
}
